"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRoundData = void 0;
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
var chance_1 = require("chance");
var tournamentState_1 = require("../../interfaces/tournamentState");
var leaderboard_1 = require("./leaderboard");
var chance = new chance_1.Chance();
var emptyState = {
    tournamentStatus: tournamentState_1.TournamentStatus.PENDING,
    inProgressTournamentStatus: null,
    roundData: null,
    questionAnswerData: null,
    leaderboard: null,
    userAnswersInfo: null,
    success: true,
};
var pendingState = __assign(__assign({}, emptyState), { tournamentStatus: tournamentState_1.TournamentStatus.PENDING });
var openedState = __assign(__assign({}, emptyState), { tournamentStatus: tournamentState_1.TournamentStatus.OPENED });
var getRoundData = function (now, isFirstRound) { return ({
    startsAt: new Date(now + 1000 * 60 * 3),
    roundNumber: isFirstRound ? 1 : 2,
    totalRounds: 2,
    questionsInRound: 10,
}); };
exports.getRoundData = getRoundData;
var getFirstRoundScheduledState = function (now) { return (__assign(__assign({}, emptyState), { tournamentStatus: tournamentState_1.TournamentStatus.IN_PROGRESS, inProgressTournamentStatus: tournamentState_1.InProgressTournamentStatus.NEXT_ROUND_SCHEDULED, roundData: (0, exports.getRoundData)(now, true), leaderboard: { users: [], total: 0 } })); };
var getNextRoundScheduledState = function (now, numUsers, withEmails) { return (__assign(__assign({}, emptyState), { tournamentStatus: tournamentState_1.TournamentStatus.IN_PROGRESS, inProgressTournamentStatus: tournamentState_1.InProgressTournamentStatus.NEXT_ROUND_SCHEDULED, roundData: (0, exports.getRoundData)(now, false), leaderboard: (0, leaderboard_1.getLeaderboardPage)(numUsers, 0, withEmails) })); };
var getInBetweenRoundsState = function (now, numUsers, withEmails, isFirstRound) { return ({
    tournamentStatus: tournamentState_1.TournamentStatus.IN_PROGRESS,
    inProgressTournamentStatus: tournamentState_1.InProgressTournamentStatus.BETWEEN_ROUNDS,
    roundData: (0, exports.getRoundData)(now, isFirstRound),
    questionAnswerData: null,
    leaderboard: (0, leaderboard_1.getLeaderboardPage)(numUsers, 0, withEmails),
    userAnswersInfo: null,
    success: true,
}); };
var getQuestionInProgressState = function (now, numUsers, withEmails, isFirstRound) {
    var leaderboard = (0, leaderboard_1.getLeaderboardPage)(numUsers, 0, withEmails);
    return {
        tournamentStatus: tournamentState_1.TournamentStatus.IN_PROGRESS,
        inProgressTournamentStatus: tournamentState_1.InProgressTournamentStatus.QUESTION_IN_PROGRESS,
        roundData: (0, exports.getRoundData)(now, isFirstRound),
        questionAnswerData: {
            questionStartsAt: new Date(now - 1000 * 60 * 1),
            questionEndsAt: new Date(now + 1000 * 60 * 10),
            answerStartsAt: new Date(now + 1000 * (60 * 10 + 1)),
            answerEndsAt: new Date(now + 1000 * 60 * 11),
            questionNumber: chance.integer({ min: 1, max: 10 }),
        },
        leaderboard: leaderboard,
        userAnswersInfo: numUsers > 0
            ? {
                totalAnswered: numUsers / 2,
                user: { nickname: leaderboard.users[0].nickname, avatar: leaderboard.users[0].avatar },
            }
            : null,
        success: true,
    };
};
var getAnswerRevealedState = function (now, numUsers, withEmails, isFirstRound) {
    var leaderboard = (0, leaderboard_1.getLeaderboardPage)(numUsers, 0, withEmails);
    return {
        tournamentStatus: tournamentState_1.TournamentStatus.IN_PROGRESS,
        inProgressTournamentStatus: tournamentState_1.InProgressTournamentStatus.ANSWER_REVEALED,
        roundData: (0, exports.getRoundData)(now, isFirstRound),
        questionAnswerData: {
            questionStartsAt: new Date(now - 1000 * 60 * 2),
            questionEndsAt: new Date(now - 1000 * 60 * 1),
            answerStartsAt: new Date(now - 1000 * (60 * 1 - 1)),
            answerEndsAt: new Date(now + 1000 * 60 * 10),
            questionNumber: chance.integer({ min: 1, max: 10 }),
        },
        leaderboard: leaderboard,
        userAnswersInfo: numUsers > 0
            ? {
                totalAnswered: numUsers,
                user: { nickname: leaderboard.users[0].nickname, avatar: leaderboard.users[0].avatar },
            }
            : null,
        success: true,
    };
};
var getFinishedState = function (now, numUsers, withEmails) { return (__assign(__assign({}, emptyState), { tournamentStatus: tournamentState_1.TournamentStatus.FINISHED, leaderboard: (0, leaderboard_1.getLeaderboardPage)(numUsers, 0, withEmails, tournamentState_1.TournamentProgressStatus.PARTICIPATED) })); };
var getTournamentState = function (_a) {
    var tournamentStatus = _a.tournamentStatus, inProgressTournamentStatus = _a.inProgressTournamentStatus, isFirstRound = _a.isFirstRound, leaderboardLimit = _a.leaderboardLimit, isAdmin = _a.isAdmin;
    var numUsers = leaderboardLimit;
    var withEmails = isAdmin;
    var now = Date.now();
    var firstRound = isFirstRound !== null && isFirstRound !== void 0 ? isFirstRound : false;
    switch (tournamentStatus) {
        case tournamentState_1.TournamentStatus.PENDING:
            return pendingState;
        case tournamentState_1.TournamentStatus.OPENED:
            return openedState;
        case tournamentState_1.TournamentStatus.IN_PROGRESS:
            if (inProgressTournamentStatus === tournamentState_1.InProgressTournamentStatus.NEXT_ROUND_SCHEDULED) {
                if (isFirstRound)
                    return getFirstRoundScheduledState(now);
                return getNextRoundScheduledState(now, numUsers, withEmails);
            }
            if (inProgressTournamentStatus === tournamentState_1.InProgressTournamentStatus.BETWEEN_ROUNDS) {
                return getInBetweenRoundsState(now, numUsers, withEmails, firstRound);
            }
            if (inProgressTournamentStatus === tournamentState_1.InProgressTournamentStatus.QUESTION_IN_PROGRESS) {
                return getQuestionInProgressState(now, numUsers, withEmails, firstRound);
            }
            if (inProgressTournamentStatus === tournamentState_1.InProgressTournamentStatus.ANSWER_REVEALED) {
                return getAnswerRevealedState(now, numUsers, withEmails, firstRound);
            }
            return emptyState;
        case tournamentState_1.TournamentStatus.FINISHED:
            return getFinishedState(now, numUsers, withEmails);
        default:
            return emptyState;
    }
};
exports.default = getTournamentState;
